import { Http } from "../utils/http.js";

export class CampaignService {
  deleteCamapignHeader(id) {
    var url = "campaign/header";
    var postData = {
      campaignHeaderParameter: {
        campaignHeaderId: id,
      },
      availabilityParameter: {
        availability: "delete",
      },
    };

    return new Http().post(url, postData);
  }
  retrieveCampaignHeaders(postData) {
    var url = "campaign/headers";
    return new Http().post(url, postData);
  }

  retrieveCampaignHeader(id, status, values, fileId, IFACA, template) {
    var url = "campaign/header";
    var postData = {};
    if (status === "create") {
      postData = {
        campaignHeaderParameter: {
          campaignCode: values.campaignCode,
          campaignNameEng: values.campaignNameEng,
          campaignNameHk: values.campaignNameZHTW,
          campaignNameCn: values.campaignNameZHCN,
          ifaCaIndicator: IFACA,
          remark: values.remark,
          fileId: fileId === "" || fileId === null ? 0 : fileId,
          campaignStartDate: values.campaignStartDate,
          campaignEndDate: values.campaignEndDate,
          template: template,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    } else {
      postData = {
        campaignHeaderParameter: {
          campaignHeaderId: id,
          campaignCode: values.campaignCode,
          campaignNameEng: values.campaignNameEng,
          campaignNameHk: values.campaignNameZHTW,
          campaignNameCn: values.campaignNameZHCN,
          ifaCaIndicator: IFACA,
          remark: values.remark,
          fileId: fileId === "" || fileId === null ? 0 : fileId,
          campaignStartDate: values.campaignStartDate,
          campaignEndDate: values.campaignEndDate,
          template: template,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    }

    return new Http().post(url, postData);
  }

  retrieveCampaignDetails(PermcampaignHeaderId, num, orderBy, orderSequence) {
    var url = "campaign/details";
    var postData = {
      pageableParameter: {
        pageNumber: 0,
        pageSize: num,
        orderBy: orderBy,
        orderSequence: orderSequence,
      },
      campaignDetailParameter: {
        campaignHeaderId: PermcampaignHeaderId,
      },
    };

    return new Http().post(url, postData);
  }

  detailUpload(PermcampaignHeaderId, importedData) {
    var url = "campaign/details/upload";
    var postData = {
      campaignDetailListParameter: {
        campaignHeaderId: PermcampaignHeaderId,
        campaignDetailList: importedData.map((data) => ({
          ...data,
          campaignHeaderId: PermcampaignHeaderId,
        })),
      },
    };
    return new Http().post(url, postData);
  }

  getValidateDetails(detailData) {
    var url = "campaign/details";
    var postData = detailData;
    return new Http().post(url, postData);
  }

  onlyExport(id, inputValue, Orderby, OrderSequence) {
    var url = "campaign/details";
    var postData = {
      pageableParameter: {
        pageNumber: 0,
        pageSize: 1000000,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignDetailParameter: {
        campaignHeaderId: id,
        ...(inputValue.clientFullNameEng && {
          clientFullNameEng: inputValue.clientFullNameEng,
        }),
        ...(inputValue.clientFullNameChi && {
          clientFullNameChi: inputValue.clientFullNameChi,
        }),
        ...(inputValue.dateOfBirthFrom && {
          dateOfBirthFrom: inputValue.dateOfBirthFrom,
        }),
        ...(inputValue.dateOfBirthTo && {
          dateOfBirthTo: inputValue.dateOfBirthTo,
        }),
        ...(inputValue.firstPolicyIssueDateFrom && {
          firstPolicyIssueDateFrom: inputValue.firstPolicyIssueDateFrom,
        }),
        ...(inputValue.firstPolicyIssueDateTo && {
          firstPolicyIssueDateTo: inputValue.firstPolicyIssueDateTo,
        }),
        ...(inputValue.latestIssuedPolicy && {
          latestIssuedPolicy: inputValue.latestIssuedPolicy,
        }),
        ...(inputValue.servAgentCode && {
          servAgentCode: inputValue.servAgentCode,
        }),
        ...(inputValue.servAgentName && {
          servAgentName: inputValue.servAgentName,
        }),
        ...(inputValue.kDollarMembership && {
          kDollarMembership: inputValue.kDollarMembership,
        }),
        ...(inputValue.redemptionStatus && {
          redemptionStatus: inputValue.redemptionStatus,
        }),
        ...(inputValue.currentPlanCode && {
          currentPlanCode: inputValue.currentPlanCode,
        }),
        ...(inputValue.title && { title: inputValue.title }),
        ...(inputValue.existingCustomer && {
          existingCustomer: inputValue.existingCustomer,
        }),
        ...(inputValue.partyId && { partyId: inputValue.partyId }),
        ...(inputValue.birthdayMonth && {
          birthdayMonth: inputValue.birthdayMonth,
        }),
        ...(inputValue.mobile && { mobile: inputValue.mobile }),
        ...(inputValue.email && { email: inputValue.email }),
        ...(inputValue.languageForCommunication && {
          languageForCommunication: inputValue.languageForCommunication,
        }),
        ...(inputValue.communicationChannel && {
          communicationChannel: inputValue.communicationChannel,
        }),
        ...(inputValue.servAgentEmail && {
          servAgentEmail: inputValue.servAgentEmail,
        }),
        ...(inputValue.mobileAreaCode && {
          mobileAreaCode: inputValue.mobileAreaCode,
        }),
        ...(inputValue.picsIndicator && {
          picsIndicator: inputValue.picsIndicator,
        }),
      },
    };
    return new Http().post(url, postData);
  }

  downloadTemplate(fileName) {
    var url = "campaign/templateDownload";
    var postData = {
      miscFileParameter: {
        fileName: fileName,
      },
    };

    return new Http().post(url, postData);
  }
}
